<template>
    <header class="header absolute pin-t pin-l pin-r flex flex-row justify-between content-center max-w-4xl mx-auto pt-17 md:pt-22 px-10 z-10">
        <router-link class="header__logo" :to="{path : '/'}">
            <logo class="w-26 h-8"></logo>
        </router-link>
        <nav ref="nav" class="header__nav">
            <div class="header__nav-content overflow-hidden">
                <router-link v-if="$route.name != 'profile'" to="/profile" :class="['text-' + headerColor, 'border-' + headerColor]" class="header__profile-link relative block font-signal-regular text-base md:text-2xl tracking-extrawide no-underline h-auto flex-no-grow">Profile</router-link>
                <a href="" @click.prevent="goBack" v-if="$route.name === 'profile'" :class="['text-' + headerColor, 'border-' + headerColor]" class="header__profile-link relative block font-signal-regular text-base md:text-2xl tracking-extrawide no-underline h-auto flex-no-grow">Close</a>
            </div>
        </nav>
    </header>
</template>

<script>
    import { mapState } from 'vuex';
    import logo from '../assets/svg/designus-logo.svg';

    export default {
        name : 'header-custom',

        components : { logo },

        computed : {
            ...mapState([
                'headerColor'
            ])
        },

        methods : {
            goBack(){
                this.$router.back();
            }
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/_globals.scss";

    .header {

        &__nav-content {
            transform-origin: right center;
            transform : rotate(90deg) translate(50%, 100%);
        }


        &__profile-link {
            padding-bottom : 4px;

            &::after {
                content : "";
                @include size(calc(100% - 10px), 2px);
                position : absolute;
                bottom : 0;
                left : 3px;
                transition : all 0.4s;

            }

            &.text-white:after {
                background-color : white;
            }

            &.text-black:after {
                background-color : black;
            }

            &:hover {
                &:after {
                    animation-name : linkhoverheader;
                    animation-duration :  0.5s;
                }
            }
        }

        @keyframes linkhoverheader {
            0% {
                width : calc(100% - 10px);
                right : 0;
                left : auto;
            }

            50% {
                width : 0;
                right : 3px;
                left : auto;
            }

            51% {
                width : 0;
                left : 3px;
                right : auto;
            }

            99% {
                width : calc(100% - 10px);
                left : 3px;
                right : auto;
            }

            100% {
                width : calc(100% - 10px);
                right : 3px;
                left : auto;
            }
        }
    }

</style>